import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { qa } from '../api/api';

const ScorecardList = () => {
  const history = useHistory();
  const [scorecards, setScorecards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadScorecards = async () => {
      try {
        const res = await qa();
        const items = res.Items || res.items || [];
        const grouped = {};
        items.forEach(item => {
          const name = item.template?.S || item.scorecard?.S;
          if (!name) return;
          const campaign = item.PK?.S || item.PK || item.campaign?.S || '';
          if (!grouped[name]) grouped[name] = campaign;
        });
        const arr = Object.keys(grouped).map(n => ({ name: n, campaign: grouped[n] }));
        setScorecards(arr);
      } catch (err) {
        console.error('Failed to load scorecards:', err);
      } finally {
        setLoading(false);
      }
    };
    loadScorecards();
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Scorecards</h1>
          <p className="text-gray-600 mt-1">All QA scorecards</p>
        </div>
        <button
          onClick={() => history.push('/scorecards?new=1')}
          className="btn-outline"
        >
          New Scorecard
        </button>
      </div>
      <div className="card">
        {loading ? (
          <div className="text-center text-gray-500">Loading...</div>
        ) : scorecards.length === 0 ? (
          <p className="text-center text-gray-500">No scorecards found.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign</th>
                  <th className="px-6 py-3" />
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {scorecards.map(sc => (
                  <tr key={sc.name} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{sc.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{sc.campaign || '—'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                      <button
                        onClick={() => history.push(`/scorecards?name=${encodeURIComponent(sc.name)}`)}
                        className="btn-outline"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScorecardList;
